export const createWidgetApiExportName = "createWidgetApi";
